import React from "react";
import { createRoot, Root } from "react-dom/client";
import { App } from "./App";
import { WidgetConfig } from "./types";
import { apiService } from "./services/api";
import "./styles/index.css";

class SimRigBuilder {
  private root: Root | null = null;
  private container: HTMLElement | null = null;

  public init(config: WidgetConfig): void {
    // Validate required config
    if (!config.container) {
      throw new Error("SimRigBuilder: container is required");
    }
    if (!config.apiUrl) {
      throw new Error("SimRigBuilder: apiUrl is required");
    }

    // Get container element
    if (typeof config.container === "string") {
      this.container = document.querySelector(config.container);
      if (!this.container) {
        throw new Error(
          `SimRigBuilder: Container element "${config.container}" not found`,
        );
      }
    } else {
      this.container = config.container;
    }

    // Add the sim-rig-builder class to the container
    this.container.classList.add("sim-rig-builder");

    // Configure API service
    console.log(
      `[WIDGET] Configuring API - baseURL: ${config.apiUrl}, creatorSlug: ${config.creatorSlug}`,
    );
    apiService.configure(config.apiUrl, config.creatorSlug);

    // Apply custom theme if provided
    const mode = config.theme?.mode || "dark";
    this.container.setAttribute("data-theme", mode);

    // Set primary color if provided
    if (config.theme?.primaryColor) {
      this.container.style.setProperty(
        "--srb-primary-color",
        config.theme.primaryColor,
      );
    }

    // Set secondary color if provided
    if (config.theme?.secondaryColor) {
      this.container.style.setProperty(
        "--srb-secondary-color",
        config.theme.secondaryColor,
      );
    }

    // Mount React app
    this.root = createRoot(this.container);
    this.root.render(<App config={config} />);
  }

  public destroy(): void {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
    if (this.container) {
      this.container.innerHTML = "";
      this.container = null;
    }
  }
}

// Export as global object
const instance = new SimRigBuilder();
export default instance;

// Also export for ES modules
export { SimRigBuilder };
